import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Button } from 'primeng/button';
import { PrimeTemplate } from 'primeng/api';
import { Card } from 'primeng/card';
import { ContactData } from '../../../adapter/dto/contact-data.dto';

@Component({
  selector: 'app-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button, PrimeTemplate, Card],
  standalone: true
})
export class ContactCardComponent {
  @Input()
  public jobTitle: string = '';

  protected trustedImageUrl?: SafeResourceUrl;

  private $contactData?: ContactData;

  public constructor(private readonly sanitizer: DomSanitizer) {}

  public get contactData(): ContactData | undefined {
    return this.$contactData;
  }

  @Input()
  public set contactData(value: ContactData | undefined) {
    this.$contactData = value;
  }

  @Input()
  public set imageUrl(value: string) {
    this.trustedImageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  protected handleImageError(event: Event): void {
    (event.target as HTMLImageElement).src = '../../../assets/avatar-default.jpg';
  }

  protected openEmail(email: string | undefined): void {
    if (email !== undefined && email !== '') {
      window.location.href = `mailto:${email}`;
    }
  }

  protected openPhoneNumber(telefon: string | undefined): void {
    if (telefon !== undefined && telefon !== '') {
      window.location.href = `tel:${telefon}`;
    }
  }
}
